import { Component } from '@angular/core';

@Component({
  selector: 'a18-menu',
  templateUrl: './a18-menu.component.html',
  styleUrl: './a18-menu.component.scss'
})
export class A18MenuComponent {

}
